var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar'),_c('aside-menu',{attrs:{"menu":_vm.menu}}),_c('router-view'),_c('aside-right'),_c('footer-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }